export default "__VITE_ASSET__D4WqThqJ__"